import React from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../store";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../../utils/constants";
import Seo from "../../shared/ui/Seo";
import VideoPlayer from "../../shared/ui/VideoPlayer";
import "./landing.css";

const FEATURES = [
  {
    to: "/app/ilanlar",
    icon: "fa-bullhorn",
    color: "primary",
    title: "Müzisyen İlanları",
    text: "Grup arayan müzisyenler, eleman arayan gruplar, özel ders ve iş ilanları.",
  },
  {
    to: "/app/studyolar",
    icon: "fa-microphone",
    color: "info",
    title: "Prova ve Kayıt Stüdyoları",
    text: "Şehrindeki stüdyoları ekipman listesi, iletişim bilgisi ve yorumlarıyla incele.",
  },
  {
    to: "/app/urunler",
    icon: "fa-shopping-cart",
    color: "accent",
    title: "Enstrüman Pazarı",
    text: "İkinci el ve sıfır enstrüman, amfi ve stüdyo ekipmanı al ya da sat.",
  },
  {
    to: "/app/haberler",
    icon: "fa-newspaper-o",
    color: "warn",
    title: "Müzik Haberleri",
    text: "Haberler, röportajlar ve yeni çıkan şarkılarla müzik dünyasını takip et.",
  },
  {
    to: "/app/etkinlikler",
    icon: "fa-ticket",
    color: "warning",
    title: "Konserler ve Etkinlikler",
    text: "Yaklaşan konserler, atölyeler ve festivaller tek bir ajandada.",
  },
  {
    to: "/app/soru-cevap",
    icon: "fa-comments",
    color: "success",
    title: "Soru - Cevap",
    text: "Enstrüman, teknik ve ekipman sorularına deneyimli müzisyenlerden cevap al.",
  },
];

const STEPS = [
  {
    title: "Profilini oluştur",
    text: "Çaldığın enstrümanları, sevdiğin türleri ve şehrini ekle; müzisyenler seni kolayca bulsun.",
  },
  {
    title: "İlan ver ya da keşfet",
    text: "Grup arkadaşı, öğrenci, stüdyo veya enstrüman ara; ihtiyacın olanı ilanla duyur.",
  },
  {
    title: "Bağlantı kur, paylaş",
    text: "Müzisyenlerle mesajlaş, profil kartını sosyal medyada paylaşarak sahneni büyüt.",
  },
];

function Home() {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const loggedIn = Boolean(currentUser?.username);

  return (
    <>
      <Seo
        path="/"
        description="Türkiye'nin müzisyen platformu: grup ve eleman ilanları, prova ve kayıt stüdyoları, ikinci el enstrüman pazarı, müzik haberleri, konserler ve soru-cevap."
      />

      <section className="black cover cover-gd lp-hero" style={{ backgroundImage: 'url("/images/b1.jpg")' }}>
        <h1>Müzisyenlerin Buluşma Noktası</h1>
        <p>
          Grup arkadaşı bul, ilan ver, prova stüdyosu ve enstrüman ara, müzik dünyasını takip et.
          Müziğe dair her şey tek platformda.
        </p>
        <div className="lp-actions">
          {loggedIn ? (
            <>
              <Link to="/app" className="btn circle white p-x-md">
                Keşfetmeye Başla
              </Link>
              <Link to={`/${currentUser.username}`} className="btn circle btn-outline b-white p-x-md">
                Profilim
              </Link>
            </>
          ) : (
            <>
              <Link to="/kayit-ol" className="btn circle white p-x-md">
                Ücretsiz Kayıt Ol
              </Link>
              <Link to="/app" className="btn circle btn-outline b-white p-x-md">
                Keşfet
              </Link>
            </>
          )}
        </div>
        <div className="lp-meta">
          <span><i className="fa fa-check" aria-hidden="true" />Ücretsiz üyelik</span>
          <span><i className="fa fa-check" aria-hidden="true" />iOS ve Android uygulaması</span>
          <span><i className="fa fa-check" aria-hidden="true" />Türkiye'nin dört bir yanından müzisyenler</span>
        </div>
      </section>

      <section className="dark lp-section">
        <div className="lp-container">
          <div className="lp-center lp-section-head">
            <span className="lp-eyebrow">Neler var?</span>
            <h2 className="lp-title">Müzik dünyan tek yerde</h2>
            <p className="lp-lead">
              Müzisyenler ve müzikseverler için ihtiyacın olan her şey; ilanlardan stüdyolara,
              enstrüman pazarından konser ajandasına.
            </p>
          </div>
          <div className="lp-grid lp-grid-3">
            {FEATURES.map((feature) => (
              <Link key={feature.to} to={feature.to} className="lp-card">
                <span className={`lp-icon ${feature.color}`}>
                  <i className={`fa ${feature.icon}`} aria-hidden="true" />
                </span>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
                <span className="lp-more">
                  İncele <i className="fa fa-angle-right" aria-hidden="true" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="black lp-section">
        <div className="lp-container">
          <div className="lp-center lp-section-head">
            <span className="lp-eyebrow">Nasıl çalışır?</span>
            <h2 className="lp-title">Üç adımda sahnedesin</h2>
          </div>
          <div className="lp-grid lp-grid-3">
            {STEPS.map((step, index) => (
              <div key={step.title} className="lp-card">
                <span className="lp-step-num">{index + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="dark lp-section">
        <div className="lp-container lp-split">
          <div>
            <span className="lp-eyebrow">Yeni</span>
            <h2 className="lp-title">Müzisyen kartını paylaş</h2>
            <p className="lp-lead" style={{ margin: 0 }}>
              Profilin; fotoğrafın, enstrümanların ve seviyenle Instagram ve TikTok için hazır bir
              karta dönüşsün. Hikâyende paylaş, takipçilerin seni muzisyen.app'te bulsun.
            </p>
            <ul className="lp-checklist">
              <li>Hikâye (9:16) ve gönderi (4:5) boyutunda hazır görsel</li>
              <li>Kişisel profil adresin: muzisyen.app/kullaniciadin</li>
              <li>Web'den ve mobil uygulamadan tek dokunuşla paylaşım</li>
            </ul>
            {loggedIn ? (
              <Link to={`/${currentUser.username}`} className="btn circle primary p-x-md">
                Kartımı Oluştur
              </Link>
            ) : (
              <Link to="/kayit-ol" className="btn circle primary p-x-md">
                Kartını Oluşturmak İçin Katıl
              </Link>
            )}
          </div>
          <div className="lp-phone">
            <img
              src="/images/kart-ornek.jpg"
              alt="Örnek müzisyen profil kartı: Deniz Yıldırım, Elektro Gitar ve Bas Gitar, İzmir"
              width={540}
              height={960}
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="black lp-section">
        <div className="lp-container">
          <div className="lp-center lp-section-head">
            <span className="lp-eyebrow">muzisyen.app</span>
            <h2 className="lp-title">Müziğin ritmine kapılın</h2>
            <p className="lp-lead">
              Müzik dünyası farklı sesler, tarzlar ve yeteneklerle dolu. Platformumuz hepsini bir araya
              getiriyor ve size müziği keşfetme ve yaratma fırsatı sunuyor.
            </p>
          </div>
          <VideoPlayer source="https://cdn.muzisyen.app/muzisyen.mp4" className="lp-video" />
        </div>
      </section>

      <section className="dark lp-section">
        <div className="lp-narrow lp-center">
          <span className="lp-eyebrow">Mobil uygulama</span>
          <h2 className="lp-title">Müzik topluluğu cebinde</h2>
          <p className="lp-lead">
            Bildirimleri anında al, mesajlarına hızlıca cevap ver ve ilanlarını her yerden yönet.
          </p>
          <div className="lp-stores">
            <a className="lp-store" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              <i className="fa fa-apple" aria-hidden="true" />
              <span>
                <small>App Store'dan</small>
                <b>İndir</b>
              </span>
            </a>
            <a className="lp-store" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
              <i className="fa fa-play" aria-hidden="true" />
              <span>
                <small>Google Play'den</small>
                <b>İndir</b>
              </span>
            </a>
          </div>
        </div>
      </section>

      {!loggedIn && (
        <section className="black lp-section">
          <div className="lp-container">
            <div className="primary lp-cta">
              <h2>Sahneye sen de çık</h2>
              <p>
                Ücretsiz profilini oluştur; grup arkadaşını, öğrencini ya da bir sonraki sahneni
                muzisyen.app'te bul.
              </p>
              <Link to="/kayit-ol" className="btn circle white p-x-md">
                Ücretsiz Kayıt Ol
              </Link>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default Home;
